import * as React from "react";
const SvgDot = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
}));
export default SvgDot;
//# sourceMappingURL=Dot.js.map